import React, { useEffect, useState } from "react";
import { Table } from "antd";
import { Link } from "react-router-dom";
import Requests from "../../pages/services/Requests";
import Header from "../header";
import SidebarNav from "../sidebar";

const Services = () => {
  const [services, setServices] = useState([]);
  const [loading, setLoading] = useState(true);

  const columns = [
    {
      title: "#",
      dataIndex: "index",
      render: (text, record, index) => index + 1,
      sorter: (a, b) => a.index - b.index,
    },
    {
      title: "Service Name",
      dataIndex: "service",
      render: (text) => <span>{text}</span>,
      sorter: (a, b) => a.service.localeCompare(b.service),
    },
    {
      title: "Client Count",
      dataIndex: "count",
      render: (text) => <span className="badge bg-primary-light">{text}</span>,
      sorter: (a, b) => a.count - b.count,
    },
    {
      title: "Popularity Rank",
      dataIndex: "rank",
      render: (text) => {
        const badgeClass = text <= 3 ? "bg-success-light" : "bg-info-light";
        return <span className={`badge ${badgeClass}`}>{text}</span>;
      },
      sorter: (a, b) => a.rank - b.rank,
    },
  ];

  useEffect(() => {
    const fetchServices = async () => {
      try {
        setLoading(true);
        const response = await Requests.getServicesStats();

        if (response.data.success) {
          // Extract and format services data
          const popularServices = response.data.data.popular_services || [];
          const formattedServices = popularServices.map((service, index) => ({
            ...service,
            rank: index + 1,
            key: index,
          }));

          setServices(formattedServices);
        }
      } catch (error) {
        console.error("Error fetching services:", error);
      } finally {
        setLoading(false);
      }
    };

    fetchServices();
  }, []);

  return (
    <>
      <Header />
      <SidebarNav />
      <div className="page-wrapper">
        <div className="content container-fluid">
          <div className="page-header">
            <div className="row">
              <div className="col-sm-12">
                <h3 className="page-title">Services</h3>
                <ul className="breadcrumb">
                  <li className="breadcrumb-item">
                    <Link to="/admin">Dashboard</Link>
                  </li>
                  <li className="breadcrumb-item active">Services</li>
                </ul>
              </div>
            </div>
          </div>

          <div className="row">
            <div className="col-sm-12">
              <div className="card">
                <div className="card-body">
                  <div className="table-responsive">
                    <Table
                      columns={columns}
                      dataSource={services}
                      loading={loading}
                      pagination={{
                        pageSize: 10,
                        showSizeChanger: false,
                        showTotal: (total, range) =>
                          `Showing ${range[0]} to ${range[1]} of ${total} services`,
                      }}
                      style={{ overflowX: "auto" }}
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default Services;